import React from 'react';
import { CtaButton } from './CtaButton';
import { Emoji } from './Emoji';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/eL3wepN3HHhz43LwsM4r44/mock_up_producto_cocina_lista_-_png.png';
const chips = [{
  emoji: '📄',
  label: '100% PDF'
}, {
  emoji: '⚡',
  label: 'Acceso en 5 min'
}, {
  emoji: '⏱️',
  label: '2 hs de cocina'
}];
const trust = [{
  emoji: '🛡️',
  label: 'Garantía 7 días'
}, {
  emoji: '🔒',
  label: 'Pago seguro'
}, {
  emoji: '💳',
  label: 'Mercado Pago'
}];
export function Hero() {
  return <header className="w-full bg-forest-900" data-id="element-117" data-mp="xaxfppm0hsm4">
      <div className="mx-auto flex max-w-[760px] flex-col items-center px-5 pb-16 pt-3 text-center sm:px-8" style={{
      paddingBottom: "0px"
    }} data-id="element-118" data-mp="sbb5lp1hcshj">
        <span className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.24em] text-cream" data-id="element-119" data-mp="nbewxchu8cvn">
          <Emoji symbol="🌿" data-id="element-120" data-mp="3czflm08u696k" />
          Close The Gap<span className="text-lime-400" data-id="element-121" data-mp="3825ywscu0bmf">™</span>
        </span>

        <h1 className="mt-6 font-display text-[2.5rem] font-black leading-[0.98] tracking-tight text-cream sm:text-6xl" style={{
        fontSize: "28px"
      }} data-id="element-122" data-mp="384s3cj4feb0f">
          Tu semana de comida.
          <span className="mt-2 block text-lime-400" data-id="element-123" data-mp="3o5j2371e3dk8">Lista. Desde hoy.</span>
        </h1>

        <img src={PRODUCT_IMAGE} alt="Mega Pack Cocina Lista: 6 tomos y 6 bonos en PDF sobre batch cooking" className="mt-2 w-full max-w-[560px]" width={560} height={420} data-id="element-124" data-mp="39a32ynlycrgz" />

        <p className="mt-1 font-display text-base font-bold tracking-tight text-lime-400 sm:text-lg" data-id="element-125" data-mp="30h9bzsx583na">
          El sistema de alimentación N°1 para argentinos
        </p>

        

        <p className="mt-3 max-w-xl text-lg leading-relaxed text-cream/75" style={{
        fontSize: "14px"
      }} data-id="element-126" data-mp="2qkmu9d045sph">
          Recetas + listas de compras + planificadores + viandas listas para llevar. Sin improvisar. Sin delivery de último momento. Sin heladera vacía.
        </p>

        <ul className="mt-6 flex flex-wrap justify-center gap-2" style={{
        paddingBottom: "0px"
      }} data-id="element-127" data-mp="2lkike5tpnw88">
          {chips.map(chip => <li key={chip.label} className="inline-flex items-center gap-2 rounded-full border border-lime-400/20 bg-forest-800 px-3.5 py-2 text-sm font-semibold text-cream" style={{
          fontSize: "8px",
          paddingRight: "4px",
          width: "101px",
          height: "30px"
        }} data-id="element-128" data-mp="s335tfryasyl">
              <Emoji symbol={chip.emoji} data-id="element-129" data-mp="ddnf1zsf6niw" />
              {chip.label}
            </li>)}
        </ul>

        <div className="mt-5 w-full max-w-md" data-id="element-130" data-mp="1b1ffd2mry4up">
          <CtaButton emoji="🥗" className="w-full" data-id="element-131" data-mp="1b04bl2tbwx3l">
            Quiero mi Mega Pack ahora
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" style={{
        paddingLeft: "0px",
        width: "342px",
        height: "52px"
      }} data-id="element-132" data-mp="112px38qyuidx">
          {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 text-sm text-cream/70" style={{
          fontSize: "10px",
          height: "12px"
        }} data-id="element-133" data-mp="x37falufynfb">
              <Emoji symbol={item.emoji} data-id="element-134" data-mp="3hqk9uf1wzmrs" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </header>;
}